import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RelatorioPrestacaoComponent } from './relatorio-prestacao.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: RelatorioPrestacaoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RelatorioPrestacaoRoutingModule { }
